var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", [
      _vm.showMineField
        ? _c(
            "tbody",
            _vm._l(_vm.mineFieldHeight, function(h) {
              return _c(
                "tr",
                { key: h },
                _vm._l(_vm.mineFieldWidth, function(w) {
                  return _c(
                    "td",
                    { key: w },
                    [
                      _c("MineBlock", {
                        attrs: {
                          openState: _vm.openState[h - 1][w - 1],
                          mineState: _vm.mineMap[h - 1][w - 1],
                          height: h - 1,
                          width: w - 1
                        },
                        on: {
                          openBlock: _vm.openBlockHandler,
                          setFlag: _vm.setFlagHandler
                        }
                      })
                    ],
                    1
                  )
                })
              )
            })
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.playState === 0
            ? "用时：" + _vm.formattedMiningTime()
            : _vm.playState === 1
              ? "胜利：共计用时" + _vm.formattedMiningTime()
              : "失败"
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [_vm._v("剩余雷数：" + _vm._s(_vm.minesRemaining))]),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectLevel,
            expression: "selectLevel"
          }
        ],
        on: {
          change: function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.selectLevel = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          }
        }
      },
      [
        _c("option", { attrs: { value: "0", disabled: "" } }, [
          _vm._v("请选择难度")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "1" } }, [
          _vm._v("简单：9*9的雷区，10个雷")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "2" } }, [
          _vm._v("简单：16*16的雷区，40个雷")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "3" } }, [
          _vm._v("困难：30*16的雷区，99个雷")
        ])
      ]
    ),
    _vm._v(" "),
    _c("button", { on: { click: _vm.refreshMineField } }, [_vm._v("开始游戏")])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf14a1f2", { render: render, staticRenderFns: staticRenderFns })
  }
}